import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "update-expense-modal"
}
const _hoisted_2 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Jadwal Keberangkatan", -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "md:flex items-center justify-between gap-4" }
const _hoisted_6 = { class: "text-sm text-grey" }
const _hoisted_7 = { class: "text-xl font-bold mb-4" }
const _hoisted_8 = { class: "text-xl font-bold mb-4" }
const _hoisted_9 = { class: "rounded-xl border-grey-2 p-5 mb-4 overflow-visible" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-11 gap-4 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 text-base font-normal" }, "Terminal"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-base font-normal" }, "Datang"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-base font-normal" }, "Berangkat"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-base font-normal" }, "+Hari")
], -1)
const _hoisted_11 = { class: "col-span-6 text-base font-semibold text-grey" }
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = { class: "col-span-2" }
const _hoisted_14 = { class: "col-span-1" }
const _hoisted_15 = { class: "flex items-center pt-5" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (!$setup.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Dialog, {
          class: "change-schedule-modal",
          showHeader: true,
          visible: $setup.showModal,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.showModal) = $event)),
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '75vw' },
          modal: true,
          contentClass: "wrap-ctn-modal-default"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "pi pi-times cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeDialog()))
                })
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Button, {
                class: "btn-back mr-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeDialog()))
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "btn-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onSubmitAct()))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(`PP ${$props.ritData.ppOrder + 1}`), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(`RIT ${$props.ritData.ritOrder + 1} : ${$props.ritData.ritName ?? '-'}`), 1)
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString($props.ritData.busName ?? '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataSource, (data, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "grid grid-cols-11 items-center gap-4 py-3 border-top-grey-lighten-5",
                    key: data
                  }, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(data?.name ?? '-'), 1),
                    _createElementVNode("div", _hoisted_12, [
                      (index !== 0)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 0,
                            modelValue: data.arrival,
                            "onUpdate:modelValue": ($event: any) => ((data.arrival) = $event),
                            type: "time",
                            class: "time-pp w-full"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (index !== $setup.dataSource.length - 1)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 0,
                            modelValue: data.departure,
                            "onUpdate:modelValue": ($event: any) => ((data.departure) = $event),
                            type: "time",
                            class: "time-pp w-full"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Dropdown, {
                        modelValue: data.dayOffset,
                        "onUpdate:modelValue": ($event: any) => ((data.dayOffset) = $event),
                        optionLabel: "name",
                        optionValue: "value",
                        id: "dayOffset",
                        options: $setup.dayOffsetOptions,
                        placeholder: "Pilih"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}